
import Vue from 'vue';
export default Vue.extend({
  name: 'CancelButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});
